// extracted by mini-css-extract-plugin
module.exports = {"backButton":"PasswordRecoveryPage_backButton__2Uoac","error":"PasswordRecoveryPage_error__8P-3J"};